import { environment } from '../../../environments/environment';
import { LoaderService } from '../../services/loader.service';
import {
  AfterViewInit,
  Component,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  SimpleChanges,
  ViewChild,
  afterEveryRender,
  DOCUMENT
} from '@angular/core';
import { Store } from '@ngrx/store';
import { UntypedFormGroup } from '@angular/forms';
import { FormService } from 'app/services/form.service';
import { AccountService } from 'app/services/account.service';
import { Router } from '@angular/router';
import { Renderer2, Inject } from '@angular/core';

import { ThemeIconService } from 'app/services/theme-icon.service';
import { MetaService } from 'app/services/meta.service';
import { Subscription } from 'rxjs';
declare const MktoForms2: any;

@Component({
  selector: 'app-lead-gen',
  templateUrl: './lead-gen.component.html',
  styleUrls: ['./lead-gen.component.scss'],
  standalone: false,
})
export class LeadGenComponent implements OnInit, AfterViewInit, OnChanges, OnDestroy {
  @ViewChild('confirmation') confirmation: any;
  form: UntypedFormGroup;
  questions: any;
  showFailure = false;
  returnRoute = location.host + '/contact-confirmation';
  formURL: string;
  oid: string;
  campaignID: string;
  recordType: string;
  countryList: any[];
  currentCustomer: any[];
  customerQuries: any[];
  cities: any[];
  emailSantizeError = false;
  reference_Information_c: string;
  emailValue: string;
  customerOrProductQuries: any[];
  contactSalesSpecificToProduct = false;
  resizewidth = true;
  productLaunchpadEmail: any[];
  showSuccess = false;
  leadGenProcessing = false;
  recipients: string;
  formElementHook;
  formProductElementHook;
  formPreFillHook;
  @Input() product: string;
  request: string;
  formValues: any;
  isVisible = false;
  requestType: string;
  ackHeader: string;
  ackDescription: string;
  isProductSuccess = false;
  accountSubscription: Subscription;
  themeSubscription: Subscription;
  metaSubscription: Subscription;
  isGenericContactForm: boolean;
  customerIdObserver: MutationObserver;
  notesInputAbortController: AbortController;

  constructor(
    private router: Router,
    public store: Store<any>,
    private renderer: Renderer2,
    @Inject(DOCUMENT) private document: Document,
    protected formService: FormService,
    public loaderService: LoaderService,
    private accountService: AccountService,
    private themeService: ThemeIconService,
    private metaService: MetaService
  ) {
    this.formPreFillHook = afterEveryRender(() => {
      const contactSubmitElement = this.document.querySelector('button[type="submit"]');
      if (contactSubmitElement) {
        MktoForms2.whenReady((form) => {
          const userInfo = localStorage.getItem('user');
          if (userInfo && userInfo.trim() !== '') {
            const parsedUserInfo = JSON.parse(userInfo);
            if (parsedUserInfo['firstName']) {
              form.setValues({ ['FirstName']: parsedUserInfo['firstName'] });
            }

            if (parsedUserInfo['lastName']) {
              form.setValues({ ['LastName']: parsedUserInfo['lastName'] });
            }

            if (parsedUserInfo['email']) {
              form.setValues({ ['Email']: parsedUserInfo['email'] });
            }
          }
        });
        this.formPreFillHook.destroy();
      }
    });

    this.formElementHook = afterEveryRender(() => {
      const submitButtonElement = this.document.querySelector('button[type="submit"]');
      if (submitButtonElement) {
        const currentTheme = this.themeService.getDefaultSetting();
        const radioElements = this.document.querySelectorAll('input[type="radio"]');
        const checkboxElements = this.document.querySelectorAll('input[type="checkbox"]');
        if (currentTheme === 'dark') {
          radioElements.forEach((radio: HTMLInputElement) => {
            radio.classList.remove('-add-suedo-elment');
            radio.classList.remove('-remove-suedo-elment');
            radio.classList.add('-add-suedo-elment');

            radio.addEventListener('click', (event) => {
              const target = event.target as HTMLInputElement;
              target.classList.remove('-add-suedo-elment');
              target.classList.remove('-remove-suedo-elment');
              target.classList.add('-remove-suedo-elment');
              const radioSiblings = Array.from(
                this.document.querySelectorAll(`input[type="radio"][name="${target.name}"]`)
              ).filter((r) => r !== radio);

              radioSiblings.forEach((sibling: HTMLInputElement) => {
                sibling.classList.remove('-remove-suedo-elment');
                sibling.classList.remove('-add-suedo-elment');
                sibling.classList.add('-add-suedo-elment');
              });
            });
          });

          checkboxElements.forEach((chkbox: HTMLInputElement) => {
            chkbox.classList.remove('-add-suedo-elment');
            chkbox.classList.remove('-remove-suedo-elment');
            chkbox.classList.add('-add-suedo-elment');

            chkbox.addEventListener('click', (event) => {
              const target = event.target as HTMLInputElement;
              if (target.checked === true) {
                target.classList.remove('-add-suedo-elment');
                target.classList.remove('-remove-suedo-elment');
                target.classList.add('-remove-suedo-elment');
              } else {
                target.classList.remove('-remove-suedo-elment');
                target.classList.remove('-add-suedo-elment');
                target.classList.add('-add-suedo-elment');
              }
            });
          });
        }

        if (currentTheme === 'light') {
          radioElements.forEach((radio: HTMLInputElement) => {
            radio.classList.remove('-add-suedo-elment');
            radio.classList.remove('-remove-suedo-elment');
            radio.removeEventListener('click', (event) => {
              const target = event.target as HTMLInputElement;
              target.classList.remove('-add-suedo-elment');
              target.classList.remove('-remove-suedo-elment');
              target.classList.add('-remove-suedo-elment');
              const radioSiblings = Array.from(
                this.document.querySelectorAll(`input[type="radio"][name="${target.name}"]`)
              ).filter((r) => r !== radio);

              radioSiblings.forEach((sibling: HTMLInputElement) => {
                sibling.classList.remove('-remove-suedo-elment');
                sibling.classList.remove('-add-suedo-elment');
                sibling.classList.add('-remove-suedo-elment');
              });
            });
          });

          checkboxElements.forEach((chkbox: HTMLInputElement) => {
            chkbox.classList.remove('-add-suedo-elment');
            chkbox.classList.remove('-remove-suedo-elment');
            chkbox.removeEventListener('click', (event) => {
              const target = event.target as HTMLInputElement;
              if (target.checked === true) {
                target.classList.remove('-add-suedo-elment');
                target.classList.remove('-remove-suedo-elment');
                target.classList.add('-remove-suedo-elment');
              } else {
                target.classList.remove('-remove-suedo-elment');
                target.classList.remove('-add-suedo-elment');
                target.classList.add('-add-suedo-elment');
              }
            });
          });
        }
        this.loaderService.loadingContent.emit(false);
        this.formElementHook.destroy();
      }
    });

    this.formProductElementHook = afterEveryRender(() => {
      if (this.product) {
        const contactProductElement = this.document.querySelector('#option8');
        if (contactProductElement) {
          const parentElement: HTMLElement = contactProductElement.parentElement.closest('.mktoFieldDescriptor');
          parentElement.style.display = 'none';
          this.formProductElementHook.destroy();
        }
      } else {
        this.formProductElementHook.destroy();
      }
    });
  }

  ngOnInit() {
    window.scrollTo({ top: 0 });
    this.oid = environment.sfOrgId;
    this.campaignID = environment.sfCampaignID;
    this.recordType = environment.sfRecordType;
    this.accountSubscription = this.accountService.pendoVisitorId.subscribe((vid) => {
      this.reference_Information_c = vid;
    });

    const metaValue = this.metaService.metadata.getValue();
    this.requestType = metaValue['request-type'] ? metaValue['request-type'] : 'sales';

    this.getAcknowledgementData();

    if (!this.product) {
      this.formValues = {
        request: this.requestType,
      };
      this.addMarketoScript(this.formValues);
    } else {
      this.formValues = {
        request: this.requestType,
        product: this.product,
      };
    }

    this.themeSubscription = this.themeService.themeInfo.subscribe((theme) => {
      const radioElements = this.document.querySelectorAll('input[type="radio"]');
      const checkboxElements = this.document.querySelectorAll('input[type="checkbox"]');
      if (theme === 'dark') {
        radioElements.forEach((radio: HTMLInputElement) => {
          if (radio.checked === true) {
            radio.classList.remove('-add-suedo-elment');
            radio.classList.remove('-remove-suedo-elment');
            radio.classList.add('-remove-suedo-elment');
          } else {
            radio.classList.remove('-add-suedo-elment');
            radio.classList.remove('-remove-suedo-elment');
            radio.classList.add('-add-suedo-elment');
          }

          radio.addEventListener('click', (event) => {
            const target = event.target as HTMLInputElement;
            target.classList.remove('-add-suedo-elment');
            target.classList.remove('-remove-suedo-elment');
            target.classList.add('-remove-suedo-elment');
            const radioSiblings = Array.from(
              this.document.querySelectorAll(`input[type="radio"][name="${target.name}"]`)
            ).filter((r) => r !== radio);

            radioSiblings.forEach((sibling: HTMLInputElement) => {
              sibling.classList.remove('-remove-suedo-elment');
              sibling.classList.remove('-add-suedo-elment');
              sibling.classList.add('-add-suedo-elment');
            });
          });
        });

        checkboxElements.forEach((chkbox: HTMLInputElement) => {
          if (chkbox.checked === true) {
            chkbox.classList.remove('-add-suedo-elment');
            chkbox.classList.remove('-remove-suedo-elment');
            chkbox.classList.add('-remove-suedo-elment');
          } else {
            chkbox.classList.remove('-add-suedo-elment');
            chkbox.classList.remove('-remove-suedo-elment');
            chkbox.classList.add('-add-suedo-elment');
          }

          chkbox.addEventListener('click', (event) => {
            const target = event.target as HTMLInputElement;

            if (target.checked === true) {
              target.classList.remove('-add-suedo-elment');
              target.classList.remove('-remove-suedo-elment');
              target.classList.add('-remove-suedo-elment');
            } else {
              target.classList.remove('-remove-suedo-elment');
              target.classList.remove('-add-suedo-elment');
              target.classList.add('-add-suedo-elment');
            }
          });
        });
      }

      if (theme === 'light') {
        radioElements.forEach((radio: HTMLInputElement) => {
          radio.classList.remove('-add-suedo-elment');
          radio.classList.remove('-remove-suedo-elment');
          radio.addEventListener('click', (event) => {
            const target = event.target as HTMLInputElement;
            target.classList.remove('-add-suedo-elment');
            target.classList.remove('-remove-suedo-elment');
            target.classList.add('-remove-suedo-elment');
            const radioSiblings = Array.from(
              this.document.querySelectorAll(`input[type="radio"][name="${target.name}"]`)
            ).filter((r) => r !== radio);

            radioSiblings.forEach((sibling: HTMLInputElement) => {
              sibling.classList.remove('-remove-suedo-elment');
              sibling.classList.remove('-add-suedo-elment');
              sibling.classList.add('-remove-suedo-elment');
            });
          });
        });

        checkboxElements.forEach((chkbox: HTMLInputElement) => {
          chkbox.classList.remove('-add-suedo-elment');
          chkbox.classList.remove('-remove-suedo-elment');
          chkbox.addEventListener('click', (event) => {
            const target = event.target as HTMLInputElement;

            if (target.checked === true) {
              target.classList.remove('-add-suedo-elment');
              target.classList.remove('-remove-suedo-elment');
              target.classList.add('-remove-suedo-elment');
            } else {
              target.classList.remove('-remove-suedo-elment');
              target.classList.remove('-add-suedo-elment');
              target.classList.add('-remove-suedo-elment');
            }
          });
        });
      }
    });
  }

  getAcknowledgementData() {
    this.metaSubscription = this.metaService.metadata.subscribe((meta) => {
      if (meta && meta['acknowledgement-form']) {
        this.ackHeader = meta['acknowledgement-form']['header'] ? meta['acknowledgement-form']['header'] : null;
        this.ackDescription = meta['acknowledgement-form']['description']
          ? meta['acknowledgement-form']['description']
          : null;
      }
    });
  }

  setAcknowledgementPage() {
    if (this.isProductSuccess && this.isVisible) {
      const contentViewer = this.document.querySelector('content-viewer');
      if (contentViewer) {
        this.renderer.setStyle(contentViewer, 'display', 'none');
      }

      const leftPanel = this.document.querySelector('.left-contact-panel');
      if (leftPanel) {
        this.renderer.setStyle(leftPanel, 'display', 'none');
        this.renderer.setStyle(leftPanel, 'min-height', 'unset');
      }

      const acknowledgement = this.document.querySelector('.acknowledgement');
      if (acknowledgement) {
        ['padding', 'border', 'box-shadow'].forEach((style) => {
          this.renderer.setStyle(acknowledgement, style, 'unset');
        });
      }
    } else if (this.isVisible) {
      const section = document.querySelector('main > article > section:first-of-type');
      if (section) {
        section.classList.add('hidden-info-section');
      }
    }
  }

  public addMarketoScript(formValues: any) {
    this.isGenericContactForm = this.metaService.metadata.getValue()['template'] === 'contact-page';

    const script = this.renderer.createElement('script');
    script.type = 'text/javascript';
    script.src = '//go.worldpay.com/js/forms2/js/forms2.min.js';
    script.async = true;
    this.renderer.appendChild(this.document.body, script);
    script.onload = () => {
      MktoForms2.loadForm('//go.worldpay.com', '092-EMI-875', 4150);

      MktoForms2.whenReady((form) => {
        this.setSelectStyling('.mktoForm select.mktoField');

        if (formValues.product) {
          this.isProductSuccess = true;
          form.setValues({ ['option8']: formValues.product });
        }

        if (this.isGenericContactForm) {
          this.presetAndHideOption4(form, formValues);
        }

        const INVALID_CHARS_PATTERN = /[<>"'`;\\()[\]{}&%]/;
        const INVALID_CHARS_MESSAGE = 'Invalid character(s) not allowed.';
        const REQUIRED_MESSAGE = 'This field is required.';
        const US_PHONE_FORMAT_MESSAGE = 'Please enter a valid US phone number in the format xxx-xxx-xxxx.';
        const NAME_VALID_PATTERN = /^[a-zA-Z0-9][a-zA-Z0-9 ]*[a-zA-Z0-9]$|^[a-zA-Z0-9]$/;
        const US_PHONE_PATTERN = /^\d{3}-\d{3}-\d{4}$/;
        const EMAIL_FORMAT_PATTERN = /^[^\s@.]+(?:\.[^\s@.]+)*@[^\s@.]+(?:\.[^\s@.]+)+$/;
        const EMAIL_FORMAT_MESSAGE = 'Must be valid email.example@yourdomain.com';

        const getFieldObj = (fieldName: string) => {
          let descriptorEl = form.getFormElem()
            .find(`[name="${fieldName}"]`)
            .closest('.mktoFieldDescriptor');
          if (!descriptorEl.length) {
            descriptorEl = form.getFormElem()
              .find(`#${fieldName}`)
              .closest('.mktoFieldDescriptor');
          }
          return descriptorEl.length ? descriptorEl.data('mktoFieldDescriptor') : null;
        };

        const getVal = (fieldObj: any): string => (fieldObj.val() ?? '').toString();

        const failWith = (fieldObj: any, message: string): false => {
          fieldObj.validationMessage = message;
          return false;
        };

        const checkRequired = (fieldObj: any, val: string): boolean | null =>
          fieldObj.required && val.length === 0
            ? failWith(fieldObj, fieldObj.requiredMessage || REQUIRED_MESSAGE)
            : null;

        const checkWhitespace = (fieldObj: any, val: string): boolean | null => {
          if (val.length > 0 && val.trim().length === 0) {
            return failWith(fieldObj, INVALID_CHARS_MESSAGE);
          }
          if (val.length > 0 && val !== val.trim()) {
            return failWith(fieldObj, INVALID_CHARS_MESSAGE);
          }
          return null;
        };

        const checkInvalidChars = (fieldObj: any, val: string): boolean | null =>
          INVALID_CHARS_PATTERN.test(val)
            ? failWith(fieldObj, INVALID_CHARS_MESSAGE)
            : null;

        const runOriginal = (original: (() => boolean) | null): boolean =>
          original ? original() : true;

        const getOriginal = (fieldObj: any): (() => boolean) | null => {
          if (!fieldObj.__mktoOriginalValidator) {
            fieldObj.__mktoOriginalValidator = fieldObj.validator ?? null;
          }
          return fieldObj.__mktoOriginalValidator;
        };

        const notesFieldObj = getFieldObj('MktoPersonNotes');
        if (notesFieldObj) {
          const notesIsRequired = !!notesFieldObj.required;
          notesFieldObj.required = false;
          notesFieldObj.requiredMessage = REQUIRED_MESSAGE;
          const originalNotesValidator = getOriginal(notesFieldObj);
          const textareaEl = form.getFormElem().find('[name="MktoPersonNotes"]').get(0) as HTMLTextAreaElement | undefined;
          let lastRawNotesValue = textareaEl ? textareaEl.value : '';

          if (textareaEl) {
            const textareaProto = Object.getOwnPropertyDescriptor(HTMLTextAreaElement.prototype, 'value');
            this.notesInputAbortController = new AbortController();
            textareaEl.addEventListener('input', () => {
              lastRawNotesValue = textareaProto?.get ? textareaProto.get.call(textareaEl) : textareaEl.value;
            }, { capture: true, signal: this.notesInputAbortController.signal });
          }

          notesFieldObj.validator = function() {
            const domVal: string = textareaEl
              ? (Object.getOwnPropertyDescriptor(HTMLTextAreaElement.prototype, 'value')?.get?.call(textareaEl) ?? '')
              : '';
            const val: string = lastRawNotesValue.length > 0 ? lastRawNotesValue : domVal;
            if (notesIsRequired && val.length === 0) {
              return failWith(notesFieldObj, REQUIRED_MESSAGE);
            }
            const whitespaceResult = checkWhitespace(notesFieldObj, val);
            if (whitespaceResult !== null) { return whitespaceResult; }
            return checkInvalidChars(notesFieldObj, val)
              ?? runOriginal(originalNotesValidator);
          };
        }

        const attachCustomerIdValidator = (): boolean => {
          const customerIdFieldObj = getFieldObj('option11');
          if (!customerIdFieldObj) { return false; }
          if (customerIdFieldObj.__mktoOriginalValidator !== undefined) { return true; }
          const originalCustomerIdValidator = getOriginal(customerIdFieldObj);
          customerIdFieldObj.validator = function() {
            const val = getVal(customerIdFieldObj);
            const option3Val = (form.getFormElem().find('[name="option3"]:checked').val() ?? '').toString().trim();
            const isRequired = option3Val.toLowerCase() === 'yes';
            if (isRequired && val.length === 0) {
              return failWith(customerIdFieldObj, REQUIRED_MESSAGE);
            }
            return checkWhitespace(customerIdFieldObj, val)
              ?? checkInvalidChars(customerIdFieldObj, val)
              ?? runOriginal(originalCustomerIdValidator);
          };
          return true;
        };

        if (!attachCustomerIdValidator()) {
          const formEl = form.getFormElem().get(0);
          if (formEl) {
            this.customerIdObserver = new MutationObserver(() => {
              if (form.getFormElem().find('[name="option11"]').length && attachCustomerIdValidator()) {
                this.customerIdObserver.disconnect();
                this.customerIdObserver = null;
              }
            });
            this.customerIdObserver.observe(formEl, { childList: true, subtree: true, attributes: true, attributeFilter: ['style', 'class'] });
          }
        }

        ['FirstName', 'LastName'].forEach((fieldName) => {
          const fieldObj = getFieldObj(fieldName);
          if (!fieldObj) { return; }
          const originalValidator = getOriginal(fieldObj);
          fieldObj.validator = function() {
            const val = getVal(fieldObj);
            return checkRequired(fieldObj, val)
              ?? checkWhitespace(fieldObj, val)
              ?? (val.length > 0 && !NAME_VALID_PATTERN.test(val) ? failWith(fieldObj, INVALID_CHARS_MESSAGE) : null)
              ?? runOriginal(originalValidator);
          };
        });

        ['Company', 'Title'].forEach((fieldName) => {
          const fieldObj = getFieldObj(fieldName);
          if (!fieldObj) { return; }
          const originalValidator = getOriginal(fieldObj);
          fieldObj.validator = function() {
            const val = getVal(fieldObj);
            return checkRequired(fieldObj, val)
              ?? checkWhitespace(fieldObj, val)
              ?? checkInvalidChars(fieldObj, val)
              ?? runOriginal(originalValidator);
          };
        });

        const emailFieldObj = getFieldObj('Email');
        if (emailFieldObj) {
          const originalEmailValidator = getOriginal(emailFieldObj);
          emailFieldObj.validator = function() {
            const val = getVal(emailFieldObj);
            return checkRequired(emailFieldObj, val)
              ?? checkInvalidChars(emailFieldObj, val)
              ?? (val.length > 0 && !EMAIL_FORMAT_PATTERN.test(val) ? failWith(emailFieldObj, EMAIL_FORMAT_MESSAGE) : null)
              ?? runOriginal(originalEmailValidator);
          };
        }

        const phoneFieldObj = getFieldObj('Phone');
        if (phoneFieldObj) {
          const originalPhoneValidator = getOriginal(phoneFieldObj);
          phoneFieldObj.validator = function() {
            const val = getVal(phoneFieldObj);
            const countryVal = (form.getFormElem().find('[name="Country"]').val() ?? '').toString().trim();
            return checkRequired(phoneFieldObj, val)
              ?? checkWhitespace(phoneFieldObj, val)
              ?? checkInvalidChars(phoneFieldObj, val)
              ?? (countryVal === 'NA' && val.length > 0 && !US_PHONE_PATTERN.test(val)
                  ? failWith(phoneFieldObj, US_PHONE_FORMAT_MESSAGE)
                  : null)
              ?? runOriginal(originalPhoneValidator);
          };
        }

        form.onSuccess((values, followUpUrl) => {
          form.getFormElem().hide();
          this.isVisible = true;
          this.setAcknowledgementPage();
          return false;
        });
      });
    };
  }

  private presetAndHideOption4(form: any, formValues: any): void {
    const contactRequestElement = this.document.querySelector('#option4');
    if (contactRequestElement) {
      form.setValues({ ['option4']: formValues.request });
      contactRequestElement.classList.remove('-value-select');
    }
  }
  setSelectStyling(selectSelector) {
    const selectFields = this.document.querySelectorAll(selectSelector);
    selectFields.forEach((selectField: HTMLSelectElement) => {
      if (!selectField.value) {
        selectField.classList.remove('-default-select');
        selectField.classList.add('-default-select');
      }
      if (selectField.value) {
        selectField.classList.remove('-value-select');
        selectField.classList.add('-value-select');
      }

      selectField.addEventListener('change', (event) => {
        const target = event.target as HTMLSelectElement;
        if (target.value === '') {
          target.classList.remove('-default-select');
          target.classList.remove('-value-select');
          target.classList.add('-default-select');
        } else {
          target.classList.remove('-value-select');
          target.classList.remove('-default-select');
          target.classList.add('-value-select');
        }
      });
    });
  }

  ngOnDestroy(): void {
    this.accountSubscription?.unsubscribe();
    this.themeSubscription?.unsubscribe();
    this.metaSubscription?.unsubscribe();
    this.formPreFillHook?.destroy();
    this.formElementHook?.destroy();
    this.formProductElementHook?.destroy();
    this.customerIdObserver?.disconnect();
    this.notesInputAbortController?.abort();
  }

  ngOnChanges(changes: SimpleChanges): void {
    let formValuesOnChange;

    const metaValue = this.metaService.metadata.getValue();
    this.requestType = metaValue['request-type'] ? metaValue['request-type'] : 'sales';

    if (!this.product) {
      formValuesOnChange = {
        request: this.requestType,
      };
    } else {
      formValuesOnChange = {
        request: this.requestType,
        product: this.product,
      };
    }
    this.addMarketoScript(formValuesOnChange);
  }

  ngAfterViewInit(): void {
    //code changes to get recipients from url
    const url = this.router.url.replace(/^\/|\/$/g, '');
    const urlPartsFragments = url.split('#');
    const urlParts = urlPartsFragments[0].split('/');
    this.recipients = urlParts[1];
  }
}
